<div
  class="navigation-container"
  markantPlatformOutsideClick
  (outsideClick)="closeDrawer()"
>
  @if ($dockerItems(); as dockerItems) {
    <nav aria-label="dock" class="dock">
      @for (item of dockerItems; track $index) {
        <markant-platform-navigation-docker-item
          [navigationItem]="item"
          [attr.data-cy]="'navigation-dock-item-' + $index"
          (clicked)="onNavItemClick(item)"
          (keydown.enter)="onNavItemClick(item)"
        ></markant-platform-navigation-docker-item>
      }
    </nav>

    @if ($activeItem(); as activeItem) {
      @if (activeItem.children.length) {
        <nav aria-label="drawer" class="drawer" [@slideInOut]="$menuState()">
          <div [@fadeInOut]="$menuState()">
            <h4>
              {{
                'dashboardOverview.navigation.' + activeItem.label + '.label'
                  | transloco
              }}
            </h4>
            <markant-platform-navigation-accordion
              [drawerItems]="activeItem.children"
            ></markant-platform-navigation-accordion>
          </div>
        </nav>
        <markant-platform-navigation-drawer-toggle
          [icon]="$drawerToggleIcon()"
          [@toggleSlide]="$menuState()"
          (toggleDrawer)="toggleDrawerOpen()"
        ></markant-platform-navigation-drawer-toggle>
      }
    }
  }
</div>
